import { useEffect, useState } from 'react';
import { EBX642_GROUP_PARAMETER_KEY, EBX642_GROUP_PARAMETER_OPTIONS, EBX642_TREATMENT_KEY, PARAMETERS } from '../constants/experimentKeys';
import { laboratoryClient } from '../utils/laboratoryClient'; //EBX642: Compare current plan (free or starter) to pro in interstitial

export const useIsEBX642Variant = () => {
  const [isEbx642Variant, setIsEbx642Variant] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      if (Object.keys(treatments).length) {
        const optionValue = treatments[EBX642_TREATMENT_KEY][PARAMETERS][EBX642_GROUP_PARAMETER_KEY];
        setIsEbx642Variant(optionValue === EBX642_GROUP_PARAMETER_OPTIONS.variant);
      }
    });
  }, [isEbx642Variant]);
  return isEbx642Variant;
};